import { useEffect } from "react";
import { useProjectDateFilter } from "ducks/project/hooks";
import { initialLayerState, initialRangeState, emptyDuration, ActionLayerKind } from "../reducers";

export default ({
  layerDispatcher,
  formLayerDispatcher,
  setRangeDate,
  setFormRangeDate,
  setDurationInterval,
  setFormDurationInterval,
}) => {
  const [dateFilterProjectData, { loading }] = useProjectDateFilter();

  useEffect(() => {
    if (loading) {
      return;
    }
    if (dateFilterProjectData?.layers) {
      layerDispatcher({ type: ActionLayerKind.AddLayers, payload: dateFilterProjectData.layers });
      formLayerDispatcher({
        type: ActionLayerKind.AddLayers,
        payload: dateFilterProjectData.layers,
      });
    } else {
      layerDispatcher({ type: ActionLayerKind.AddLayers, payload: initialLayerState });
      formLayerDispatcher({
        type: ActionLayerKind.AddLayers,
        payload: initialLayerState,
      });
    }
    if (dateFilterProjectData?.rangeDate) {
      setRangeDate(dateFilterProjectData.rangeDate.map(date => new Date(date)));
      setFormRangeDate(dateFilterProjectData.rangeDate.map(date => new Date(date)));
    } else {
      setRangeDate(initialRangeState);
      setFormRangeDate(initialRangeState);
    }
    if (dateFilterProjectData?.durationInterval) {
      setDurationInterval(dateFilterProjectData?.durationInterval);
      setFormDurationInterval(dateFilterProjectData?.durationInterval);
    } else {
      setDurationInterval(emptyDuration);
    }
  }, [
    dateFilterProjectData,
    formLayerDispatcher,
    layerDispatcher,
    loading,
    setDurationInterval,
    setFormDurationInterval,
    setFormRangeDate,
    setRangeDate,
  ]);
};
